import { render } from "./PlanningPartners.vue?vue&type=template&id=2a97f284&ts=true"
import script from "./PlanningPartners.vue?vue&type=script&lang=ts"
export * from "./PlanningPartners.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/mmwapp/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__